/**
 * Discount Promo functionality
 * Handles discount code application and cart drawer integration
 */

window.addEventListener("DOMContentLoaded", () => {
  const discountButtons = document.querySelectorAll('.discount-promo__button');

  // Function to inject discount info into cart drawer
  const injectDiscountInfo = (discountCode) => {
    const discountsContainer = document.querySelector('[data-discounts]');
    if (discountsContainer && discountCode) {
      // Remove any existing discount info
      const existingInfo = discountsContainer.querySelector('.applied-discount');
      if (existingInfo) {
        existingInfo.remove();
      }

      // Create new discount info element
      const discountInfo = document.createElement('div');
      discountInfo.className = 'cart__item-row applied-discount';
      discountInfo.style.cssText = 'padding: 12px 0; border-top: 1px solid #e8e8e1; display: flex; justify-content: space-between; align-items: center;';

      // Get translation or use fallback
      const discountLabel = window.theme && window.theme.strings && window.theme.strings.discountCode
        ? window.theme.strings.discountCode
        : 'קוד הנחה';
      const removeLabel = window.theme && window.theme.strings && window.theme.strings.remove
        ? window.theme.strings.remove
        : 'הסר';

      discountInfo.innerHTML = `
        <div style="display: flex; align-items: center; gap: 8px;">
          <span style="color: #236642; font-weight: 500; font-size: 14px;">${discountLabel}: ${discountCode}</span>
        </div>
        <button type="button" class="remove-discount" style="color: #999; font-size: 12px; text-decoration: underline; border: none; background: none; cursor: pointer; padding: 0;">
          ${removeLabel}
        </button>
      `;
      discountsContainer.appendChild(discountInfo);

      // Add remove functionality
      const removeBtn = discountInfo.querySelector('.remove-discount');
      removeBtn.addEventListener('click', () => {
        sessionStorage.removeItem('appliedDiscountCode');
        discountInfo.remove();

        // Reset discount promo buttons
        const promoButtons = document.querySelectorAll('.discount-promo__button');
        promoButtons.forEach(btn => {
          btn.style.display = 'flex';
          const container = btn.closest('.discount-promo__container');
          const message = container.querySelector('.discount-promo__message');
          if (message) {
            message.style.display = 'none';
          }
        });
      });
    }
  };

  // Function to modify checkout buttons to include discount code and clear sessionStorage
  const modifyCheckoutButtons = (discountCode) => {
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], a.cart__checkout, .additional-checkout-buttons button');
    checkoutButtons.forEach(btn => {
      if (btn.tagName === 'A') {
        const url = new URL(btn.href, window.location.origin);
        url.searchParams.set('discount', discountCode);
        btn.href = url.toString();
      } else {
        // For form submit buttons, intercept the form submission
        const form = btn.closest('form');
        if (form && !form.dataset.discountModified) {
          form.dataset.discountModified = 'true';
          form.addEventListener('submit', function(e) {
            const storedCode = sessionStorage.getItem('appliedDiscountCode');
            if (storedCode) {
              e.preventDefault();

              // KEY FIX: Clear sessionStorage BEFORE redirecting to checkout
              // This ensures discount doesn't persist if user returns from checkout
              sessionStorage.removeItem('appliedDiscountCode');

              // Redirect to checkout with discount code
              window.location.href = `/checkout?discount=${encodeURIComponent(storedCode)}`;
            }
          });
        }
      }
    });
  };

  // Function to open cart drawer
  const openCartDrawer = () => {
    if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.openCartDrawer === 'function') {
      theme.cart.openCartDrawer();
    } else if (typeof theme !== 'undefined' && theme.CartDrawer && typeof theme.CartDrawer.open === 'function') {
      theme.CartDrawer.open();
    } else {
      // Fallback: trigger cart drawer button click
      const cartDrawerTrigger = document.querySelector('[data-cart-drawer-toggle]') ||
                               document.querySelector('.js-drawer-open-right') ||
                               document.querySelector('.cart-link');
      if (cartDrawerTrigger) {
        cartDrawerTrigger.click();
      }
    }
  };

  // Handle discount button clicks
  discountButtons.forEach(button => {
    button.addEventListener('click', async function() {
      const discountCode = this.getAttribute('data-discount-code');
      const successMessage = this.getAttribute('data-success-message');
      const showSuccess = this.getAttribute('data-show-success') === 'true';
      const buttonText = this.querySelector('.discount-promo__button-text');
      const loader = this.querySelector('.discount-promo__button-loader');
      const messageEl = this.closest('.discount-promo__container').querySelector('.discount-promo__message');

      if (!discountCode) return;

      // Show loading state
      this.disabled = true;
      buttonText.style.display = 'none';
      loader.style.display = 'inline-block';
      messageEl.style.display = 'none';

      try {
        // Store discount code in session storage for checkout
        sessionStorage.setItem('appliedDiscountCode', discountCode);

        // Hide button and show success message
        this.style.display = 'none';

        const discountAppliedLabel = window.theme && window.theme.strings && window.theme.strings.discountApplied
          ? window.theme.strings.discountApplied
          : 'Discount applied';
        const displayMessage = showSuccess && successMessage ? successMessage : `${discountAppliedLabel}: ${discountCode}`;

        messageEl.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#236642" stroke-width="2" style="display: inline-block; vertical-align: middle; margin-left: 8px;">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          <span>${displayMessage}</span>
        `;
        messageEl.style.display = 'flex';
        messageEl.style.alignItems = 'center';
        messageEl.style.justifyContent = 'center';
        messageEl.style.gap = '8px';
        messageEl.style.color = '#236642';
        messageEl.style.fontWeight = '500';
        messageEl.style.padding = '12px';
        messageEl.style.backgroundColor = '#ffffff';
        messageEl.style.borderRadius = '30px';

        // Inject discount info and modify checkout buttons after cart drawer opens
        setTimeout(() => {
          injectDiscountInfo(discountCode);
          modifyCheckoutButtons(discountCode);
        }, 300);

        // Also listen for cart drawer open events to reapply
        const applyOnDrawerOpen = () => {
          setTimeout(() => {
            injectDiscountInfo(discountCode);
            modifyCheckoutButtons(discountCode);
          }, 100);
        };
        document.addEventListener('CartDrawer:open', applyOnDrawerOpen);
        document.addEventListener('drawerOpen', applyOnDrawerOpen);

      } catch (error) {
        console.error('Error applying discount:', error);

        // Show error message
        messageEl.textContent = 'Could not apply discount. Please try again.';
        messageEl.style.display = 'block';
        messageEl.style.color = '#d32f2f';

        // Reset button
        this.disabled = false;
        this.style.display = 'flex';
        buttonText.style.display = 'inline';
        loader.style.display = 'none';

        // Hide error message after 5 seconds
        setTimeout(() => {
          messageEl.style.display = 'none';
        }, 5000);
      }
    });
  });

  // On page load, check if there's a stored discount code and apply it to checkout buttons
  const storedCode = sessionStorage.getItem('appliedDiscountCode');
  if (storedCode) {
    // Hide buttons and show success message for discount promo blocks
    const promoButtons = document.querySelectorAll('.discount-promo__button');
    promoButtons.forEach(btn => {
      const btnCode = btn.getAttribute('data-discount-code');
      if (btnCode === storedCode) {
        const container = btn.closest('.discount-promo__container');
        const messageEl = container.querySelector('.discount-promo__message');
        const successMessage = btn.getAttribute('data-success-message');
        const showSuccess = btn.getAttribute('data-show-success') === 'true';

        btn.style.display = 'none';

        const discountAppliedLabel = window.theme && window.theme.strings && window.theme.strings.discountApplied
          ? window.theme.strings.discountApplied
          : 'Discount applied';
        const displayMessage = showSuccess && successMessage ? successMessage : `${discountAppliedLabel}: ${storedCode}`;

        messageEl.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#236642" stroke-width="2" style="display: inline-block; vertical-align: middle; margin-left: 8px;">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          <span>${displayMessage}</span>
        `;
        messageEl.style.display = 'flex';
        messageEl.style.alignItems = 'center';
        messageEl.style.justifyContent = 'center';
        messageEl.style.gap = '0';
        messageEl.style.color = '#236642';
        messageEl.style.fontWeight = '500';
        messageEl.style.padding = '12px';
        messageEl.style.backgroundColor = '#ffffff';
        messageEl.style.borderRadius = '30px';
      }
    });

    // Apply immediately
    setTimeout(() => modifyCheckoutButtons(storedCode), 500);

    // Listen for cart drawer opens and inject discount info
    document.addEventListener('CartDrawer:open', () => {
      setTimeout(() => {
        injectDiscountInfo(storedCode);
        modifyCheckoutButtons(storedCode);
      }, 100);
    });
    document.addEventListener('drawerOpen', () => {
      setTimeout(() => {
        injectDiscountInfo(storedCode);
        modifyCheckoutButtons(storedCode);
      }, 100);
    });
  }
});
